.container {
	display: flex;
	flex-direction: column;
}

.tableWrapper {
	padding: 0.5rem 1rem;
	border-bottom: 1px solid #e5e7eb;
	background: #fafafa;
	overflow-x: auto;
}

.table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.8125rem;

	th {
		text-align: left;
		font-size: 0.6875rem;
		font-weight: 600;
		color: #6b7280;
		text-transform: uppercase;
		letter-spacing: 0.025em;
		padding: 0.25rem 0.5rem;
		border-bottom: 1px solid #e5e7eb;
	}

	td {
		padding: 0.375rem 0.5rem;
		color: #111827;
		font-weight: 500;
	}

	tr:not(:last-child) td {
		border-bottom: 1px solid #f3f4f6;
	}
}
